function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36 25H40V24H36V25ZM15 13.2V15H37V13.2C37 11.8 37.8 10.6 39 10.2V5.9C39 4.9 38.2 4 37.1 4H14.9C13.9 4 13 4.8 13 5.9V10.3C14.2 10.6 15 11.8 15 13.2ZM15 18H37V16H15V18ZM12 25H16V24H12V25ZM41.4 11.3C41 10.9 40.5 10.7 40 10.7C39.5 10.7 39 10.9 38.6 11.3C38.2 11.7 38 12.2 38 12.7V18.5C38 18.8 37.8 19.1 37.4 19.1H14.6C14.3 19.1 14 18.8 14 18.5V12.8C14 12.1 13.6 11.4 13 11.1C11.5 10.4 10 11.4 10 12.8V23H42V12.7C42 12.2 41.8 11.7 41.4 11.3Z",
  fill: "#B3B3B3"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 2H4V25H6V2Z",
  fill: "#860935"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.7 4.2L5.8 0.3C5.4 -0.1 4.7 -0.1 4.3 0.3L0.3 4.2C0.1 4.4 0 4.7 0 4.9C0 5.2 0.1 5.4 0.3 5.7C0.7 6.1 1.4 6.1 1.8 5.7L5 2.6L8.2 5.7C8.6 6.1 9.3 6.1 9.7 5.7C10.1 5.3 10.1 4.6 9.7 4.2Z",
  fill: "#860935"
});

function SvgSofaHeigth({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 25,
    viewBox: "0 0 42 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCA0MiAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zNiAyNUg0MFYyNEgzNlYyNVpNMTUgMTMuMlYxNUgzN1YxMy4yQzM3IDExLjggMzcuOCAxMC42IDM5IDEwLjJWNS45QzM5IDQuOSAzOC4yIDQgMzcuMSA0SDE0LjlDMTMuOSA0IDEzIDQuOCAxMyA1LjlWMTAuM0MxNC4yIDEwLjYgMTUgMTEuOCAxNSAxMy4yWk0xNSAxOEgzN1YxNkgxNVYxOFpNMTIgMjVIMTZWMjRIMTJWMjVaTTQxLjQgMTEuM0M0MSAxMC45IDQwLjUgMTAuNyA0MCAxMC43QzM5LjUgMTAuNyAzOSAxMC45IDM4LjYgMTEuM0MzOC4yIDExLjcgMzggMTIuMiAzOCAxMi43VjE4LjVDMzggMTguOCAzNy44IDE5LjEgMzcuNCAxOS4xSDE0LjZDMTQuMyAxOS4xIDE0IDE4LjggMTQgMTguNVYxMi44QzE0IDEyLjEgMTMuNiAxMS40IDEzIDExLjFDMTEuNSAxMC40IDEwIDExLjQgMTAgMTIuOFYyM0g0MlYxMi43QzQyIDEyLjIgNDEuOCAxMS43IDQxLjQgMTEuM1oiIGZpbGw9IiNCM0IzQjMiLz4KPHBhdGggZD0iTTYgMkg0VjI1SDZWMloiIGZpbGw9IiM4NjA5MzUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjcgNC4yTDUuOCAwLjNDNS40IC0wLjEgNC43IC0wLjEgNC4zIDAuM0wwLjMgNC4yQzAuMSA0LjQgMCA0LjcgMCA0LjlDMCA1LjIgMC4xIDUuNCAwLjMgNS43QzAuNyA2LjEgMS40IDYuMSAxLjggNS43TDUgMi42TDguMiA1LjdDOC42IDYuMSA5LjMgNi4xIDkuNyA1LjdDMTAuMSA1LjMgMTAuMSA0LjYgOS43IDQuMloiIGZpbGw9IiM4NjA5MzUiLz4KPC9zdmc+Cg==";
export { SvgSofaHeigth as ReactComponent };